<template>
  <div>
    <div class="question d-flex bg-primary text-white">
      <!-- eslint-disable-next-line max-len -->
      <div class="d-flex align-items-center justify-content-center flex-column pl-3 pr-3 question-number border-right h-100 text-center">
        <!-- eslint-disable vue/no-v-html -->
        <strong v-html="$t('test.question_number', { number: questionNumber })" />
        <small class="op-6" v-html="$t('test.level', { difficulty: getQuestionLevelFormatted })" />
        <!-- eslint-enable vue/no-v-html -->
      </div>
      <div class="d-flex align-items-start justify-content-center flex-column pl-3 pr-3 question-label h-100">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <small class="op-6" v-html="$t('test.category', { category: displayModule })" />
        <div>{{ displayQuestion && displayQuestion.label }}</div>
      </div>
    </div>
    <div :class="`layout-content d-flex ${displayExplanaition ? 'justify-content-between' :'justify-content-center'}`">
      <answer-kind
        :kind="displayQuestion && displayQuestion.kind"
        :answers="displayQuestion && displayQuestion.answers"
        :image="getQuestionImage"
        :correction="showAnswer ? correction : null"
        :clear="clearFill"
      />
      <div v-if="displayExplanaition" class="explaination">
        <b-card>
          <h4 class="mb-2">
            {{ $t('test.explaination') }}
          </h4>
          <p>{{ displayQuestion.explaination }}</p>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
  import AnswerKind from '@/components/answer-kind';

  export default {
    name: 'TestContentComponent',
    components: {
      AnswerKind,
    },
    props: {
      testInfo: {
        type: Object,
        default: null,
      },
      previousQuestion: {
        type: Object,
        default: null,
      },
      previousQuestionModuleLabel: {
        type: String,
        default: null,
      },
      question: {
        type: Object,
        default: null,
      },
      correction: {
        type: Object,
        default: null,
      },
      moduleLocalisedLabel: {
        type: String,
        default: null,
      },
      showAnswer: {
        type: Boolean,
        default: false,
      },
      clearFill: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      questionNumber() {
        return this.testInfo.question_number;
      },
      displayQuestion() {
        return this.showAnswer ? this.previousQuestion : this.question;
      },
      displayModule() {
        return this.showAnswer ? this.previousQuestionModuleLabel : this.moduleLocalisedLabel;
      },
      displayExplanaition() {
        return this.showAnswer && this.displayQuestion.explaination;
      },
      getQuestionImage() {
        if (this.showAnswer) {
          return this.previousQuestion.image !== undefined ? this.previousQuestion.image : null;
        }

        return this.question.image !== undefined ? this.question.image : null;
      },
      getQuestionLevelFormatted() {
        if (this.showAnswer) {
          return this.previousQuestion && this.previousQuestion.question_difficulty.label.replace(' ', '&nbsp;');
        }

        return this.question && this.question.question_difficulty.label.replace(' ', '&nbsp;');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  .layout-content {
    position: relative;
  }

  .explaination {
    max-width: 300px;
  }

  .question {
    height: $nav-height;

    /deep/ .question-level {
      width: $button-width;

      div {
        text-align: center;
        font-size: 12px;

        small {
          color: rgba($white, 0.8) !important;
        }
      }
    }
    .question-number {
      width: $button-width;
    }

    .question-label {
      width: 100 - ($button-width);
      font-weight: bold;
    }

    .question-number {
      span {
        line-height: 1.2rem;
      }

      /deep/ .question-number-number {
        font-size: 1.5rem;
        font-weight: bold;
      }
    }
  }
</style>
